import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import omit from "lodash/omit";
import PropTypes from "prop-types";
import { themeConfigShape } from "@jutro/prop-types";
import { DropdownSelectField } from "../../inputs/DropdownSelectField/DropdownSelectField";
export var omittedDropdownProps = ["value", "defaultValue", "availableValues", "dataType", "autoTrim", "onValueChange", "model", "path", "validationMessages", "dataPath", "validator", "inputType"];
export var themeChooserPropTypes = _objectSpread(_objectSpread({}, omit((null == DropdownSelectField ? void 0 : DropdownSelectField.propTypes) || {}, omittedDropdownProps)), {}, {
  availableThemes: PropTypes.arrayOf(themeConfigShape.isRequired).isRequired,
  onThemeChange: PropTypes.func,
  theme: themeConfigShape,
  defaultTheme: themeConfigShape,
  skipPropagation: PropTypes.bool
});
export var themeChooserDefaultProps = _objectSpread(_objectSpread({}, omit((null == DropdownSelectField ? void 0 : DropdownSelectField.defaultProps) || {}, omittedDropdownProps)), {}, {
  availableThemes: [],
  skipPropagation: !1,
  label: "",
  id: "ThemeChooser"
});
export var themeChooserStorybookPropNames = ["id", "availableThemes", "onThemeChange", "className", "label", "theme", "skipPropagation"];